import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { Heart } from "lucide-react";

export default function Auth({ mode }) {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const isLogin = mode === "login";
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null); setLoading(true);
    try {
      const user = isLogin
        ? await login(form.email, form.password)
        : await register(form);
      const target = user.role === "admin" ? "/admin" : (loc.state?.from || "/dashboard");
      nav(target);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12" data-testid={isLogin ? "login-page" : "register-page"}>
      <div className="flex items-center gap-2 mb-6">
        <div className="w-10 h-10 rounded-2xl flex items-center justify-center" style={{background:"linear-gradient(135deg,#2D7A78,#4FA8A6)"}}>
          <Heart className="text-white" size={20}/>
        </div>
        <div>
          <div className="font-display font-extrabold">Dr. Hariom</div>
          <div className="text-xs text-[#5A6D6D] tracking-widest uppercase">Pediatric Care</div>
        </div>
      </div>
      <h1 className="font-display font-black text-3xl mb-2">{isLogin ? "Welcome back" : "Create your account"}</h1>
      <p className="text-sm text-[#5A6D6D] mb-6">{isLogin ? "Sign in to access your child's profile & consultations." : "Add child profiles, book consultations, track growth."}</p>

      <form onSubmit={submit} className="card-soft space-y-4">
        {!isLogin && (
          <div>
            <label className="text-xs font-semibold text-[#5A6D6D]">FULL NAME</label>
            <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="w-full mt-1 px-3 py-2.5 rounded-xl border border-[#E5EBEB]" data-testid="signup-name"/>
          </div>
        )}
        <div>
          <label className="text-xs font-semibold text-[#5A6D6D]">EMAIL</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="w-full mt-1 px-3 py-2.5 rounded-xl border border-[#E5EBEB]" data-testid="auth-email"/>
        </div>
        {!isLogin && (
          <div>
            <label className="text-xs font-semibold text-[#5A6D6D]">PHONE (WHATSAPP)</label>
            <input value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} className="w-full mt-1 px-3 py-2.5 rounded-xl border border-[#E5EBEB]" placeholder="+91..." data-testid="signup-phone"/>
          </div>
        )}
        <div>
          <label className="text-xs font-semibold text-[#5A6D6D]">PASSWORD</label>
          <input required type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="w-full mt-1 px-3 py-2.5 rounded-xl border border-[#E5EBEB]" data-testid="auth-password"/>
        </div>
        {err && <div className="text-sm text-[#B3261E] bg-[#FFE2E2] rounded-lg p-2" data-testid="auth-error">{err}</div>}
        <button disabled={loading} className="btn-primary w-full justify-center" data-testid="auth-submit">
          {loading ? "Please wait..." : (isLogin ? "Login" : "Sign up")}
        </button>
      </form>
      <div className="text-center text-sm text-[#5A6D6D] mt-4">
        {isLogin ? (
          <>New here? <Link to="/register" className="text-[#2D7A78] font-semibold">Create account</Link></>
        ) : (
          <>Already registered? <Link to="/login" className="text-[#2D7A78] font-semibold">Login</Link></>
        )}
      </div>
    </div>
  );
}
